import React, { useState, useEffect, useRef } from "react";
import { FileText, X, Send, Eye } from 'lucide-react';
import apiService from '../config';
import html2pdf from 'html2pdf.js';
import { useLanguage } from '../StoreContext/LanguageContext';
import { useSignature } from '../DigitalSignature/UseSignatue';
import SignaturePad from '../DigitalSignature/SignaturePad';
import SendTrackingModal from '../CommonModel/SendTrackingModal'; // adjust path as needed

const PrathmikAdhisuchna = ({ onUpdated, setSelectedComponent, setSubComponent, modalParams, shouldRestoreModal, onNavigateWithModal, setShouldRestoreModal }) => {
  // Add debugging at the top of the component
  console.log('PrathmikAdhisuchna props:', {
    onNavigateWithModal: typeof onNavigateWithModal,
    modalParams,
    shouldRestoreModal
  });
  const { language, translations } = useLanguage();
  const [formData, setFormData] = useState({
    // Read-only fields (fetch but don't update)
    acquisition_proposal_no: '',
    propsal_publication_date: '',
    propsal_publication_no: '',

    // Editable fields
    section1_content: '',
    project_description: '',
    project_social_benfit: '',
    displacement_reason: '',
    social_impact: '',
    appointed_administrator: '',
    project_name: '',
    acquisition_incharge_name: '',
    acquisition_regional_incharge_name: '',
    section_11_tip: '',
    section_11_bhusampadan_no: '',
    section_11_office_name: '',
    section_11_branch_name: '',
    section_11_notification: '',
    section_11_email: '',
    section_11_address: '',
    section_11_mobile_no: '',
    section_11_date: '',

    // Data Entry
    section_11_backToLAODate: '',
    section_11_is_send_DRO: '',
  });

  // Define which fields are editable
  const editableFields = [
    'section1_content',
    'propsal_publication_date',
    'project_description',
    'project_social_benfit',
    'displacement_reason',
    'social_impact',
    'appointed_administrator',
    'section_11_tip',
    'section_11_bhusampadan_no',
    'section_11_office_name',
    'section_11_branch_name',
    'section_11_notification',
    'section_11_email',
    'section_11_address',
    'section_11_mobile_no',
    'section_11_date',
    // 'project_name'

    // Data Entry 
    'section_11_backToLAODate',
    'section_11_is_send_DRO',
  ];

  const [loading, setLoading] = useState(false);
  const [loadingRecords, setLoadingRecords] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [hasUserEditedSection1, setHasUserEditedSection1] = useState(false); // NEW STATE
  const [hasUserEditedTip, setHasUserEditedTip] = useState(false); // NEW STATE
  const notificationContentRef = useRef(null);
  const [groupedData, setGroupedData] = useState([]);
  const [projectId, setProjectId] = useState(null); // Changed from [] to null
  const [proposalId, setProposalId] = useState(null); // Changed from [] to null
  const [usersCollector, setUsersCollector] = useState([]);
  // Samanvay
  const [showSendToSamanvayModal, setshowSendToSamanvayModal] = useState(false);
  const [selectedDocumentSamanvay, setselectedDocumentSamanvay] = useState(null);
  const [remarksSamanvay, setremarksSamanvay] = useState('Approved');
  const [sendingToSamanvay, setsendingToSamanvay] = useState(false);
  const [usersSamanvay, setusersSamanvay] = useState([]);
  const [loadingusersSamanvay, setLoadingusersSamanvay] = useState(false);
  const [selectedUserSamanvay, setselectedUserSamanvay] = useState('');
  // Collector
  const [showSendToCollectorModal, setshowSendToCollectorModal] = useState(false);
  const [selectedDocumentCollector, setselectedDocumentCollector] = useState(null);
  const [remarksCollector, setremarksCollector] = useState('Approved');
  const [sendingToCollector, setsendingToCollector] = useState(false);
  const [usersCollectorAll, setusersCollectorAll] = useState([]);
  const [loadingusersCollector, setLoadingusersCollector] = useState(false);
  const [selectedUserCollector, setselectedUserCollector] = useState('');
  // LAO
  const [showSendToLAOModal, setshowSendToLAOModal] = useState(false);
  const [selectedDocumentLAO, setselectedDocumentLAO] = useState(null);
  const [remarksLAO, setremarksLAO] = useState('Approved');
  const [sendingToLAO, setsendingToLAO] = useState(false);
  const [usersLAO, setusersLAO] = useState([]);
  const [loadingusersLAO, setLoadingusersLAO] = useState(false);
  const [selectedUserLAO, setselectedUserLAO] = useState('');
  // Documents Viewer state
  const [showDocumentViewer, setShowDocumentViewer] = useState(false); // Unified document viewer modal
  const [fileUrlToView, setFileUrlToView] = useState('');
  const [isPDFToView, setIsPDFToView] = useState(false);

  //Punarvarsan
  const [rehabType, setRehabType] = useState("non-punarvarshan");

  // Button Status
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [collectorEditCompletedbuttonDisabled, setCollectorEditCompletedbuttonDisabled] = useState(false);
  const [openSection93, setOpenSection93] = useState(false);

  const [showSendToTehsildarModal, setShowSendToTehsildarModal] = useState(false);
  const [usersTehsildar, setUsersTehsildar] = useState([]);
  const [selectedUserTehsildar, setSelectedUserTehsildar] = useState('');
  const [remarksTehsildar, setRemarksTehsildar] = useState('');
  const [selectedDocumentTehsildar, setSelectedDocumentTehsildar] = useState(null);
  const [loadingUsersTehsildar, setLoadingUsersTehsildar] = useState(false);
  const [sendingToTehsildar, setSendingToTehsildar] = useState(false);
  const [section11IsSendDRO, setSection11IsSendDRO] = useState(null);
  const [showSendToLAOTrackingModal, setShowSendToLAOTrackingModal] = useState(false);
  const [showSendToSamanvayTrackingModal, setShowSendToSamanvayTrackingModal] = useState(false);

  const [uploadingDataEntry, setUploadingDataEntry] = useState(false);
  const [uploadedDataEntryFileUrl, setUploadedDataEntryFileUrl] = useState('');
  const [selectedDocumentCollector2, setselectedDocumentCollector2] = useState(null);
  const [selectedDocumentSamanvay2, setselectedDocumentSamanvay2] = useState(null);

// OPTIONAL but recommended: A state to track which document is actively being signed
// so you don't overwrite Document 1's signature with Document 2's signature.
const [activeSamanvayDoc, setActiveSamanvayDoc] = useState(1);
const [selectedDocumentLAO2, setselectedDocumentLAO2] = useState(null);
const[isSendToLAO , setIsSendToLAO] = useState(false);

// Tracks which document is actively being signed (1 or 2) to prevent UI conflicts
const [activeLAODoc, setActiveLAODoc] = useState(1);
  const ROLES = {
    COLLECTOR: 1,
    LAO: 3,
    SAMANVAY: 6,
    PROJECT_INCHARGE: 18,
    DATA_ENTRY: 14
  };

  // ADD THESE NEW STATE VARIABLES HERE:
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertConfig, setAlertConfig] = useState({
    title: '',
    message: '',
    type: 'success'
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmConfig, setConfirmConfig] = useState({
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
    type: 'warning'
  });

  // Digital signature
  const { uploadStatus, uploadError, selectedSignDocument, resetSignatureState, signDocument } = useSignature();
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [pdfForSigning, setPdfForSigning] = useState(null);

  const userData = JSON.parse(localStorage.getItem('userData'));
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);
  const laoName = usersLAO?.[0]?.full_name || 'N/A';
  const laoDesi = usersLAO?.[0]?.designation || 'N/A';
  const laoEmail = usersLAO?.[0]?.email || 'N/A';
  console.log('User Role:', userRole);
  console.log('User Name:', laoName);
  console.log('User Designation:', laoDesi);
  //  ADD / MODIFY THIS BLOCK (place it after userRole is parsed)
  const isReadOnlyViewerRole = [ROLES.LAO, ROLES.SAMANVAY, ROLES.COLLECTOR].includes(userRole);

  // New state for direct file viewing (Samanvay & Collector)
  const [section11FileUrl, setSection11FileUrl] = useState(null);
  const [section11FileLoading, setSection11FileLoading] = useState(false);
  const [section11FileError, setSection11FileError] = useState(null);

  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printHTML, setPrintHTML] = useState('');

  // Project Id
  useEffect(() => {
    const getProjectInfo = () => {
      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name
          };
        } catch (e) {
          console.error('Error parsing selected project (selectedProject):', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          const projectId = user.data?.project_id || user.project_id;
          const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
          return {
            id: projectId,
            name: projectName
          };
        } catch (e) {
          console.error('Error parsing user data (userData):', e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setProjectId(projectInfo.id);
    console.log('Current Project Info:', projectInfo);
  }, []);

  // Proposal id
  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

      if (currentProposal) {
        try {
          return {
            proposalId: currentProposal?.data?.default_proposal ||
              currentProposal?.data?.proposal_id ||
              currentProposal?.default_proposal ||
              currentProposal?.proposal_id ||
              null
          }
        } catch (e) {
          console.error('Error parsing current project data (getProposalInfo):', e);
        }
      }
      return { proposalId: null };
    };

    const proposalInfo = getProposalInfo();
    setProposalId(proposalInfo.proposalId);
    console.log('Current Project-Proposal Info:', proposalInfo);
  }, []);

  useEffect(() => {
    if (projectId && proposalId) {
      fetchusersSamanvay();
    }
  }, [projectId, proposalId]);

  useEffect(() => {
    if (!projectId || !proposalId) return;

    if (isReadOnlyViewerRole) {
      // Samanvay + Collector → directly fetch the final PDF
      const fetchFinalSection11 = async () => {
        setSection11FileLoading(true);
        setSection11FileError(null);

        try {
          const res = await apiService.getSectionFile(projectId, proposalId, "section11");

          if (res?.status === 200 && res.data?.length > 0) {
            const fileMeta = res.data[0];
            setSection11FileUrl(fileMeta.file_path);
          } else {
            setSection11FileError("The previous step is not completed.");
          }
        } catch (err) {
          console.error("Failed to load Section-11 file:", err);
          setSection11FileError("Failed to load document. Please try again later.");
        } finally {
          setSection11FileLoading(false);
        }
      };

      fetchFinalSection11();
    } else {
      // LAO / Data Entry → keep original behavior
      fetchPrathmikAdhisuchnaData();
    }
  }, [projectId, proposalId, userRole]);
const [sendToSamanvay , setSendToSamanvay] = useState(false)
const [sendToSamanvayFinal , setSendToSamanvayFinal] = useState(false)
const [sendToCollector , setSendToCollector] = useState(false)
const [sendToLAO , setSendToLAO] = useState(false)
const [sendbacktoLAO, setSendBacktoLAO] = useState(false)
      useEffect(() => {
    const fetchButtonState = async () => {
      try {
        if (!projectId || !proposalId) return;
        const res = await apiService.getTrackingwiseButton(projectId,proposalId,"section11");
        console.log("Sec11 button response:", res);
        setSendToSamanvay(!res?.stages?.SamanvaySection11?.active)
        setSendToCollector(!res?.stages?.CollectorSection11?.active)
        setSendToSamanvayFinal(!res?.stages?.SamanvayFinalSection11?.active)
        setSendToLAO(!res?.stages?.LAOPublish?.active)
        setSendBacktoLAO(res?.stages?.Back_LAOPublish?.active)
      } catch (error) {
        console.error("Error fetching button state:", error);
      }
    };
    fetchButtonState();
  }, [projectId, proposalId]);

useEffect(() => {
  const fetchButtonState = async () => {
    try {
      if (!projectId || !proposalId) return;

      const res = await apiService.getTrackingwiseSEC11Button(projectId,proposalId);


      // setIsSendToLAO(res?.LAOPublish?.complete)


      console.log("API response:", res);

      // Correct mapping
      // setButtonDisabled(!res?.isEditable);

    } catch (error) {
      console.error("Error fetching button state:", error);
      // setButtonDisabled(true); // fail-safe
    }
  };  fetchButtonState();
}, [projectId, proposalId]);

  useEffect(() => {
    if (!projectId || !proposalId) return;

    const role = ROLES.COLLECTOR;
    const fetchUsersCollector = async () => {
      try {
        const response = await apiService.getAllAssignUserCollector(role, projectId, projectId);
        console.log('Collector users:', response);
        if (response.status === 200 && response.data) {
          console.log("----------Collector users fetched successfully:", response.data);
          setUsersCollector(Array.isArray(response.data) ? response.data : []);
        } else {
          setUsersCollector([]);
        }
      } catch (error) {
        console.error('Error fetching Collector users:', error);
        setUsersCollector([]);
      } finally {

      }
    };
    fetchUsersCollector();
  }, [projectId, proposalId]);

  // fetch Samanvay users
  const fetchusersSamanvay = async () => {
    const role = ROLES.SAMANVAY;
    setLoadingusersSamanvay(true);
    try {
      const response = await apiService.getAllAssignUserRoleSamanvay(role, projectId, proposalId);
      console.log('Samanvay users:', response);
      if (response.status === 200 && response.data) {
        setusersSamanvay(Array.isArray(response.data) ? response.data : []);
      } else {
        setusersSamanvay([]);
      }
    } catch (error) {
      console.error('Error fetching Samanvay users:', error);
      setusersSamanvay([]);
    } finally {
      setLoadingusersSamanvay(false);
    }
  };

  useEffect(() => {
    if (showSendToSamanvayModal) {
      fetchusersSamanvay();
    }
  }, [showSendToSamanvayModal]);

  const getFinalDocument = () => {
    // If digital signature exists → use signed PDF
    if (selectedSignDocument) {
      return selectedSignDocument;
    }

    // Else → use uploaded document
    if (selectedDocumentSamanvay) {
      return selectedDocumentSamanvay;
    }

    return null;
  };

  // Handle Send to Samanvay
  const handleSendToSamanvay = async () => {
    // Note: If Document 2 gets signed, make sure getFinalDocument() or a similar function 
    // captures the signed version of Doc 2 if necessary.
    const finalDocument = getFinalDocument();

    if (!finalDocument) {
      showAlert('Document Required', 'Please upload or sign a document');
      return;
    }

    if (!selectedUserSamanvay || !selectedDocumentSamanvay) {
      alert('Please select a user and upload a document to send to Samanvay Officer.');
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required.');
      return;
    }

    if (!selectedDocumentSamanvay) {
      alert('Please generate the Section 11 document first.');
      return;
    }

    setsendingToSamanvay(true);
    let response;

    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarksSamanvay);
      formData.append('usr_id', selectedUserSamanvay);
      formData.append('document', finalDocument); // Primary Document
      
      // ADDED: Append document1 if Collector role and document exists
      if (userRole === ROLES.COLLECTOR && selectedDocumentSamanvay2) {
        // If you need to send the *signed* version of doc 2, ensure you reference that specific state here
        formData.append('document1', selectedDocumentSamanvay2);
      }

      if(userRole === ROLES.LAO){
         response = await apiService.postTrackingSamanvaySection11(formData);
      }
      if(userRole === ROLES.COLLECTOR){
        response = await apiService.postTrackingSamanvayFinalSection11(formData);
      }

      console.log('Send to Samanvay response:', response);

      // --- API 2: new AddSignature endpoint ---
      await apiService.postAddSignaturePDF(
        projectId,
        proposalId,
        "section11",
        finalDocument
      );
      
      // Optional: You may need a second postAddSignaturePDF call here if Document 2 requires the same backend processing

      if (response.status === 200) {
        alert(
          translations[language]?.SuccessfullySentToSamanvayOfficer
          || "Successfully sent to Samanvay Officer!"
        );
        setshowSendToSamanvayModal(false);
        setselectedUserSamanvay('');
        setremarksSamanvay('Approved');
        setselectedDocumentSamanvay(null);
        setselectedDocumentSamanvay2(null); // Clear second doc on success
        fetchButtonStatus();
        resetSignatureState();

        if (isReadOnlyViewerRole) {
          const fetchFinalSection11 = async () => {
            setSection11FileLoading(true);
            setSection11FileError(null);

            try {
              const res = await apiService.getSectionFile(projectId, proposalId, "section11");

              if (res?.status === 200 && res.data?.length > 0) {
                const fileMeta = res.data[0];
                setSection11FileUrl(fileMeta.file_path);
              } else {
                setSection11FileError("No Section-11 document has been generated yet.");
              }
            } catch (err) {
              console.error("Failed to load Section-11 file:", err);
              setSection11FileError("Failed to load document. Please try again later.");
            } finally {
              setSection11FileLoading(false);
            }
          };

          fetchFinalSection11();
        }

      } else {
        alert('Failed to send to Samanvay Officer. Please try again.');
      }
    } catch (error) {
      console.error('Error sending to Samanvay:', error);
      alert('Failed to send to Samanvay Officer. Please try again.');
    } finally {
      setsendingToSamanvay(false);
    }
  };

  // fetch Collector users
  const fetchUsersAllCollector = async () => {
    const role = ROLES.COLLECTOR;
    setLoadingusersCollector(true);
    try {
      const response = await apiService.getAllAssignUserCollector(role, projectId, proposalId);
      console.log('Collector users:', response);
      if (response.status === 200 && response.data) {
        setusersCollectorAll(Array.isArray(response.data) ? response.data : []);
      } else {
        setusersCollectorAll([]);
      }
    } catch (error) {
      console.error('Error fetching Collector users:', error);
      setusersCollectorAll([]);
    } finally {
      setLoadingusersCollector(false);
    }
  };

  useEffect(() => {
    if (showSendToCollectorModal) {
      fetchUsersAllCollector();
    }
  }, [showSendToCollectorModal]);

  // Handle Send to Collector
const handleSendToCollector = async () => {
    if (!selectedUserCollector || !selectedDocumentCollector) {
      alert('Please select a user and upload the primary document to send to Collector Officer.');
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required.');
      return;
    }

    setsendingToCollector(true);

    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarksCollector);
      formData.append('usr_id', selectedUserCollector);
      formData.append('document', selectedDocumentCollector);
      
      // ADDED: Append second document if it exists
      if (selectedDocumentCollector2) {
        formData.append('document1', selectedDocumentCollector2);
      }

      const response = await apiService.postTrackingCollectorSection11(formData);
      console.log('Send to Collector response:', response);

      if (response.status === 200) {
        alert(
          translations[language]?.SuccessfullySentToCollectorOfficer
          || "Successfully sent to Collector Officer!"
        );
        await fetchPrathmikAdhisuchnaData();
        setshowSendToCollectorModal(false);
        setselectedUserCollector('');
        setremarksCollector('Approved');
        setselectedDocumentCollector(null);
        setselectedDocumentCollector2(null); // Reset second document
        fetchButtonStatus();
        resetSignatureState();

      } else {
        alert('Failed to send to Collector Officer. Please try again.');
      }
    } catch (error) {
      console.error('Error sending to Collector:', error);
      alert('Failed to send to Collector Officer. Please try again.');
    } finally {
      setsendingToCollector(false);
    }
  };

  // fetch LAO users
  const fetchusersLAO = async () => {
    const role = 3;
    setLoadingusersLAO(true);
    try {
      const response = await apiService.getAssignLAO(role, projectId, proposalId);
      console.log('LAO users:', response);
      if (response.status === 200 && response.data) {
        setusersLAO(Array.isArray(response.data) ? response.data : []);
      } else {
        setusersLAO([]);
      }
    } catch (error) {
      console.error('Error fetching LAO users:', error);
      setusersLAO([]);
    } finally {
      setLoadingusersLAO(false);
    }
  };

  useEffect(() => {
    if (projectId && proposalId) {
      fetchusersLAO();
    }
  }, [projectId, proposalId]);

  // // to fetch lao signed pdf 
  // useEffect(() => {
  //   const fetchSectionFile = async () => {
  //     if (projectId && proposalId && showSendToLAOModal) {
  //       try {
  //         const response = await apiService.getSectionFile(projectId, proposalId, "section11");

  //         if (response?.status === 200 && response.data?.length > 0) {
  //           const fileMeta = response.data[0];
  //           const fileUrl = fileMeta.file_path;

  //           // fetch the actual file from the URL
  //           const res = await fetch(fileUrl);
  //           const blob = await res.blob();

  //           const file = new File([blob], "Section-11.pdf", { type: blob.type || "application/pdf" });
  //           setselectedDocumentLAO(file);
  //         } else {
  //           alert("No Section-11 document found.");
  //         }
  //       } catch (err) {
  //         console.error("Error fetching Section-11 file:", err);
  //         // alert("❌ Failed to fetch Section-11 document.");
  //       }
  //     }
  //   };

  //   fetchSectionFile();
  // }, [showSendToLAOModal, projectId, proposalId]);

  const handleViewSection11 = async () => {
    if (!projectId || !proposalId) {
      alert("Missing project or proposal id");
      return;
    }

    try {
      const response = await apiService.getSectionFile(projectId, proposalId, "section11");

      if (response?.status === 200 && response.data?.length > 0) {
        const fileMeta = response.data[0];
        const fileUrl = fileMeta.file_path;

        // directly open in new tab
        window.open(fileUrl, "_blank", "noopener,noreferrer");
      } else {
        alert("No Section-11 document found.");
      }
    } catch (err) {
      console.error("Error fetching Section-11 file:", err);
      alert("❌ Failed to fetch Section-11 document.");
    }
  };

  // Handle Send to LAO
  const handleSendToLAO = async () => {
    if (!selectedUserLAO || !selectedDocumentLAO) {
      alert('Please select a user and upload a primary document to send to LAO Officer.');
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required.');
      return;
    }

    setsendingToLAO(true);

    try {
      const formData = new FormData();
      formData.append('project_id', projectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarksLAO);
      formData.append('usr_id', selectedUserLAO);
      formData.append('document', selectedDocumentLAO);

      // ADDED: Append document1 if it exists
      if (selectedDocumentLAO2) {
        formData.append('document1', selectedDocumentLAO2);
      }

      const response = await apiService.postTrackingLAOPublish(formData);
      console.log('Send to LAO response:', response);

      // Primary document signature tracking
      await apiService.postAddSignaturePDF(
        projectId,
        proposalId,
        "section11",               // ← change this string if LAO uses different section name
        selectedDocumentLAO
      );

      // Optional: Add second call to postAddSignaturePDF for selectedDocumentLAO2 if your backend requires it for the secondary document.

      if (response.status === 200) {
        alert(
          translations[language]?.SuccessfullySentToLAOOfficer
          || "Successfully sent to LAO Officer!"
        );

        if (isReadOnlyViewerRole) {
          // Samanvay + Collector → directly fetch the final PDF
          const fetchFinalSection11 = async () => {
            setSection11FileLoading(true);
            setSection11FileError(null);

            try {
              const res = await apiService.getSectionFile(projectId, proposalId, "section11");

              if (res?.status === 200 && res.data?.length > 0) {
                const fileMeta = res.data[0];
                setSection11FileUrl(fileMeta.file_path);
              } else {
                setSection11FileError("No Section-11 document has been generated yet.");
              }
            } catch (err) {
              console.error("Failed to load Section-11 file:", err);
              setSection11FileError("Failed to load document. Please try again later.");
            } finally {
              setSection11FileLoading(false);
            }
          };

          fetchFinalSection11();
        }

        await fetchPrathmikAdhisuchnaData();
        setshowSendToLAOModal(false);
        setselectedUserLAO('');
        setremarksLAO('Approved');
        setselectedDocumentLAO(null);
        setselectedDocumentLAO2(null); // Clear second doc on success
        fetchButtonStatus();
        resetSignatureState();

      } else {
        alert('Failed to send to LAO Officer. Please try again.');
      }
    } catch (error) {
      console.error('Error sending to LAO:', error);
      alert('Failed to send to LAO Officer. Please try again.');
    } finally {
      setsendingToLAO(false);
    }
  };

  // Unified function to handle viewing documents (for both modals)
  const handleViewDocument = (urlOrFile) => {
    if (!urlOrFile) return;

    let url;
    let isPdf;

    if (urlOrFile instanceof File) {
      url = URL.createObjectURL(urlOrFile);
      isPdf = urlOrFile.type === 'application/pdf';
    } else { // Assuming it's a URL string from backend
      url = urlOrFile;
      isPdf = urlOrFile.toLowerCase().includes('.pdf');
    }

    setFileUrlToView(url);
    setIsPDFToView(isPdf);
    setShowDocumentViewer(true);
  };

  const closeDocumentViewer = () => {
    setShowDocumentViewer(false);
    // Revoke Object URL if it was created from a File object
    if (fileUrlToView.startsWith('blob:')) {
      URL.revokeObjectURL(fileUrlToView);
    }
    setFileUrlToView('');
    setIsPDFToView(false);
  };

  // Button Disable
  const fetchButtonStatus = async () => {
    try {
      if (!projectId || !proposalId) return;

      // setLoading(true);
      let response;

      // Edit button disable
      response = await apiService.getfetchSamanvayButtonSection11(projectId, proposalId);
      setCollectorEditCompletedbuttonDisabled(!response.buttonDisable);

      switch (userRole) {
        case ROLES.LAO:
          response = await apiService.getfetchSamanvayButtonSection11(projectId, proposalId);
          break;
        case ROLES.SAMANVAY:
          response = await apiService.getfetchCollectorButtonSection11(projectId, proposalId);
          break;
        case ROLES.COLLECTOR:
          response = await apiService.getfetchLAOPublishButton(projectId, proposalId);
          break;
        default:
          return;
      }
      setButtonDisabled(!response.buttonDisable);
    } catch (error) {
      console.error("Error fetching DSLR button state:", error);
    } finally {
      // setLoading(false); // Only set loading to false for main data fetch
    }
  };

  useEffect(() => {
    fetchButtonStatus();
  }, [projectId, proposalId]);

  const fetchPrathmikAdhisuchnaData = async () => {

    // Add validation to ensure both IDs are valid numbers
    if (!projectId || !proposalId || projectId <= 0 || proposalId <= 0) {
      console.log('Invalid project or proposal ID:', { projectId, proposalId });
      return;
    }

    const locationParams = { proposalId };
    console.log('Fetching Prathmik Adhisuchna data with:', locationParams);
    console.log('Fetching Prathmik Adhisuchna data with: -', projectId);

    try {
      setLoadingRecords(true);
      console.log("---------------------------1");

      const result = await apiService.getLandHolding(projectId, locationParams);
      console.log("---------------------------2");

      // proposal data - Remove _lao logic
      if (result.status === 200 && Array.isArray(result.proposalData) && result.proposalData.length > 0) {
        const item = result.proposalData[0]; // Taking first record for proposal data

        const newFormData = {};
        Object.keys(formData).forEach(key => {
          newFormData[key] = item[key] !== undefined && item[key] !== null ? item[key] : '';
        });
        setFormData(newFormData);

        // Check if section1_content exists in API data
        if (item.section1_content &&
          item.section1_content.trim() !== '' &&
          item.section1_content !== 'N/A' &&
          item.section1_content !== 'null' &&
          item.section1_content !== 'undefined') {
          setHasUserEditedSection1(true); // Mark as having API content
        }
        if (item.section_11_tip &&
          item.section_11_tip.trim() !== '' &&
          item.section_11_tip !== 'N/A' &&
          item.section_11_tip !== 'null' &&
          item.section_11_tip !== 'undefined') {
          setHasUserEditedTip(true); // Mark as having API content
        }
      }

      // Land Acquisition data
      if (result.status === 200 && Array.isArray(result.data)) {
        if (projectId && proposalId) {
          fetchusersLAO();
        }
        const grouped = {};

        result.data.forEach(item => {
          // Only include if owners array exists and has data
          if (Array.isArray(item.owners) && item.owners.length > 0) {
            const key = `${item.dist_name}-${item.taluka_name}-${item.village_name}`;
            if (!grouped[key]) {
              grouped[key] = [];
            }

            // Push each owner as a separate record
            item.owners.forEach(owner => {
              grouped[key].push({
                survey_no: owner.survey_no,
                owner_name: owner.owner_name,
                aqr_area: owner.owner_aqr_area
              });
            });
          }
        });

        // Convert to array for rendering
        const groupedArray = Object.entries(grouped).map(([key, records]) => {
          const [dist, taluka, village] = key.split('-');
          const total = records.reduce((sum, r) => sum + parseFloat(r.aqr_area || 0), 0);
          return { dist, taluka, village, records, total };
        });

        setGroupedData(groupedArray);
      }


    } catch (error) {
      console.error('Error fetching Prathmik Adhisuchna data:', error);
      alert('❌ Error fetching proposal data.');
    } finally {
      setLoadingRecords(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(async () => {
      if (projectId && proposalId) {
        fetchPrathmikAdhisuchnaData();

        // ✅ Pre-load existing uploaded document URL for View button
        try {
          const fileResponse = await apiService.getSectionFile(projectId, proposalId, "section11");
          if (fileResponse?.status === 200 && fileResponse.data?.length > 0) {
            setUploadedDataEntryFileUrl(fileResponse.data[0].file_path);
          }
        } catch (err) {
          // No file yet, that's fine
        }
      }
    }, 100);
    return () => clearTimeout(timer);
  }, [projectId, proposalId]);

  // Fetch data when component mounts - FIXED
  useEffect(() => {
    // Add a small delay to ensure both projectId and proposalId are set
    const timer = setTimeout(() => {
      if (projectId && proposalId) {
        fetchPrathmikAdhisuchnaData();
      }
    }, 100); // Small delay to ensure state is updated

    return () => clearTimeout(timer);
  }, [projectId, proposalId]);

  // Debug function - remove this in production
  const debugSectionContent = () => {
    console.log('=== Section Content Debug ===');
    console.log('formData.section1_content:', formData.section1_content);
    console.log('hasUserEditedSection1:', hasUserEditedSection1);
    console.log('Content length:', formData.section1_content ? formData.section1_content.length : 0);
    console.log('Is content different from default:', formData.section1_content && formData.section1_content.trim() !== getDefaultSection1Content().trim());
    console.log('==============================');
  };

  // Call debug function whenever formData changes
  useEffect(() => {
    if (formData.section1_content) {
      debugSectionContent();
    }
  }, [formData.section1_content]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Only allow changes to editable fields
    if (editableFields.includes(name)) {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));

      // If user is editing section1_content, mark it as edited
      if (name === 'section1_content') {
        setHasUserEditedSection1(true);
      }
      if (name === 'section_11_tip') {
        setHasUserEditedTip(true);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (section11IsSendDRO === null) {
      alert("Please select Yes or No for Section 11 Send to DRO");
      return;
    }

    if (!proposalId) {
      alert('❌ No proposal ID found for update.');
      return;
    }

    try {
      setLoading(true);
      // const updateData = {};

      // Only update editable fields - remove _lao logic
      // editableFields.forEach(key => {
      //   updateData[key] = formData[key];
      // });

      const updateData = {
        section_11_date: formData.section_11_date || new Date(),
        section_11_mobile_no: formData.section_11_mobile_no || '',
        section_11_office_name: formData.section_11_office_name || '',
        section_11_branch_name: formData.section_11_branch_name || '',
        section_11_notification: formData.section_11_notification || '',
        section_11_email: formData.section_11_email || laoEmail || '',
        section_11_address: formData.section_11_address || '',


        section1_content: formData.section1_content?.trim()
          ? formData.section1_content
          : getDefaultSection1Content(),

        section_11_tip: formData.section_11_tip?.trim()
          ? formData.section_11_tip
          : getDefaultTip(),

        appointed_administrator: formData.appointed_administrator?.trim()
          ? formData.appointed_administrator
          : getDefaultAnusuchi5(),

        section_11_bhusampadan_no: formData.section_11_bhusampadan_no || '',
        section_11_rehabilitation_plan_summary: formData.section_11_rehabilitation_plan_summary,
        // appointed_administrator: formData.appointed_administrator,
        project_description: formData.project_description,
        project_social_benfit: formData.project_social_benfit,
        displacement_reason: formData.displacement_reason,
        social_impact: formData.social_impact,
        section_11_is_send_DRO:
          section11IsSendDRO === true ? 1 : 0,

      };

      // Data Entry
      if (userRole === ROLES.DATA_ENTRY) {
        updateData.section_11_backToLAODate = formData.section_11_backToLAODate
      }

      const result = await apiService.updateProposal(
        proposalId,
        updateData
      );
      if (result.status === 200) {
        alert('✅ Proposal updated successfully!');
        setIsEditing(false); // Exit editing mode after successful save
        if (onUpdated) onUpdated();
        fetchPrathmikAdhisuchnaData(); // Refresh data after update
      } else {
        alert('❌ Failed to update proposal.');
      }
    } catch (err) {
      console.error('Error updating proposal:', err);
      alert('❌ Error while updating proposal.');
    } finally {
      setLoading(false);
    }
  };


  // Alternative method using browser's native print functionality
  const handlePrintView = () => {
    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      alert('Please allow popups to use the print feature.');
      return;
    }

    // to section11FileUrl se print karo
    if (!notificationContentRef.current) {
      if (section11FileUrl) {
        printWindow.location.href = section11FileUrl;
      } else {
        printWindow.close();
        alert('Document abhi available nahi hai print ke liye.');
      }
      return;
    }

    // Normal flow - ref available hai
    const tempDiv = notificationContentRef.current.cloneNode(true);

    const droElements = tempDiv.querySelectorAll('.assign-dro-section');
    droElements.forEach(el => el.remove());

    const content = tempDiv.innerHTML;

    // Create HTML for print window
    const printHTML = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>प्रारंभिक अधिसूचना</title>
      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;600;700&display=swap" rel="stylesheet">
      <style>
        @page {
          size: A4 portrait;   /* Orientation */
          margin-top: 0.19in;
          margin-bottom: 0.25in;
          margin-left: 0.81in;
          margin-right: 0.5in;
        }
        
        * {
          box-sizing: border-box;
        }
        
        body {
          font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
          font-size: 12px;
          line-height: 1.4;
          color: black;
          background: white;
          margin: 0;
          padding: 0;
        }
        
        .print-container {
          width: 100%;
          max-width: none;
          background: white;
        }

        .pr-3{
        padding-right:1rem;
        }
        
        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 1rem;
          page-break-inside: auto !important;
        }
  
        thead {
          display: table-header-group;
        }

        tr {
            page-break-inside: avoid;
            page-break-after: auto;
        }

        td, th {
          border: 1px solid black;
          padding: 8px;
          text-align: center;
          font-size: 11px;
          page-break-inside: avoid;
        }
        
        h1, h2, h3, h4, h5, h6 {
          margin: 1rem 0 0.5rem 0;
          page-break-after: avoid;
          font-weight: bold;
        }
        
        p {
          margin: 0.5rem 0;
          text-align: justify;
          line-height: 1.5;
          orphans: 3;
          widows: 3;
        }

        .semi-bold { font-weight: 600; }
        .text-sm { font-size: 0.875rem; }
        .text-lg { font-size: 1.125rem; }
        .text-2xl { font-size: 1.8rem; }
        .flex { display: flex; }
        .justify-between { justify-content: space-between; }
        .items-end { align-items: flex-end; }
        .text-center { text-align: center; }
        .mt-44 { margin-top: 1rem; }
        .m-10{ margin: 5rem; }
        .font-bold { font-weight: bold; }
        .underline { text-decoration: underline; }
        .indent-8 { text-indent: 2rem; }        
        .mt-8 { margin-top: 2rem; }        
        .mb-2 { margin-bottom: 0.5rem; }        
        .mb-6 { margin-bottom: 1.5rem; }
        .flex { display: flex; }
        .justify-center{ justify-content: center; }
        .w-auto{
          width:auto;
          max-width: 28rem;
        }

        .space-y-4 > * + * { margin-top: 1rem; }
        
        .mx-auto{
          margin-left: auto;
          margin-right: auto;
          width : 8%;
          margin-bottom:2px;
        }

        .border-black{ border : 1.5px solid black; }

        @media print {
        .no-print {
            display: none !important;
          }
          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
          
          .page-break {
            page-break-after: always;
          }
          
          table {
            page-break-inside: avoid;
          }
          
          tr {
            page-break-inside: avoid;
          }
          
          table {
            page-break-inside: auto !important;
          }

          thead {
            display: table-header-group; /* repeat header on each page */
          }

          tfoot {
            display: table-footer-group;
          }

          tr {
            page-break-inside: avoid; /* avoid breaking inside a single row */
            page-break-after: auto;
          }

          td, th {
            page-break-inside: avoid;
            page-break-after: auto;
          }

          .page-break-avoid {
            page-break-inside: avoid;
            break-inside: avoid;
          }
        }
      </style>
    </head>
    <body>
      <div class="print-container">
        ${content}
      </div>
      <script>
        window.onload = function() {
          window.focus();
          window.print();
        };
      </script>
    </body>
    </html>
  `;

    printWindow.document.write(printHTML);
    printWindow.document.close();
  };

  // to generate pdf directly
  // Generate PDF file from notificationContentRef
  const generatePDFFile = async () => {
    if (!notificationContentRef.current) {
      alert("No content available to generate PDF");
      return null;
    }

    const element = notificationContentRef.current;
    const opt = {
      margin: 0.5,
      filename: "Section11.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" }
    };

    // Get PDF as Blob
    const pdfBlob = await html2pdf().from(element).set(opt).outputPdf('blob');

    // Wrap into File object
    return new File([pdfBlob], "Section11.pdf", { type: "application/pdf" });
  };


  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Restore modal state from parameters
  useEffect(() => {
    if (shouldRestoreModal && modalParams) {

      setshowSendToCollectorModal(true);
      fetchUsersAllCollector();

      // Restore previous selections
      pendingRestore.current = {
        user: modalParams.selectedUser || '',
        remarks: modalParams.remarks || '',
      };

      setremarksCollector(modalParams.remarks || '');

      // Reset flag so modal doesn't restore again automatically
      if (setShouldRestoreModal) {
        setShouldRestoreModal(false);
      }
    }
  }, [shouldRestoreModal, modalParams, setShouldRestoreModal]);

  useEffect(() => {
    if (pendingRestore.current) {

      if (usersCollectorAll.length > 0) {
        setselectedUserCollector(pendingRestore.current.user);
        setremarksCollector(pendingRestore.current.remarks);

        pendingRestore.current = null; // clear after applying
      }
    }
  }, [usersCollectorAll]);

  const pendingRestore = useRef(null);

  // Navigate to covering letters with modal state
  const handleCoveringLetterClick = () => {
    console.log('handleCoveringLetterClick called');
    console.log('onNavigateWithModal type:', typeof onNavigateWithModal);

    // Add validation
    if (typeof onNavigateWithModal !== 'function') {
      console.error('onNavigateWithModal is not a function:', onNavigateWithModal);
      alert('Navigation function is not available. Please check the component props.');
      return;
    }

    const modalState = {
      selectedUser: selectedUserCollector,
      userId: selectedUserCollector,
      remarks: remarksCollector,
      selectedDocumentName: selectedDocumentCollector?.name || null,
      timestamp: new Date().getTime()
    };

    console.log('Modal state for covering letters:', modalState);

    // Close the modal before navigating
    setshowSendToCollectorModal(false);

    // Use the correct component name for Section 11
    console.log('Calling onNavigateWithModal with CoveringLettersSection11');
    onNavigateWithModal('CoveringLettersSection11', modalState);
  };

  const handleDataEntryFileSelect = async (e) => {
    const file = e.target.files[0];

    if (!file) {
      return;
    }

    if (!projectId || !proposalId) {
      alert('Project ID and Proposal ID are required.');
      e.target.value = ''; // Reset file input
      return;
    }

    // Show confirmation alert
    const userConfirmed = window.confirm(
      `Selected file: ${file.name}\n\nDo you want to upload this document?`
    );

    if (!userConfirmed) {
      e.target.value = ''; // Reset file input
      return;
    }

    setUploadingDataEntry(true);

    try {
      const response = await apiService.postAddSignaturePDF(
        projectId,
        proposalId,
        "section11",
        file
      );

      if (response.status === 200) {
        alert('Document uploaded successfully!');
        // Optionally refresh data
        await fetchPrathmikAdhisuchnaData();
        try {
          const fileResponse = await apiService.getSectionFile(projectId, proposalId, "section11");
          if (fileResponse?.status === 200 && fileResponse.data?.length > 0) {
            setUploadedDataEntryFileUrl(fileResponse.data[0].file_path);
          }
        } catch (err) {
          console.error("Error fetching uploaded file URL:", err);
        }
      } else {
        alert('Failed to upload document. Please try again.');
      }
    } catch (error) {
      console.error('Error uploading document:', error);
      alert('Failed to upload document. Please try again.');
    } finally {
      setUploadingDataEntry(false);
      e.target.value = ''; // Reset file input for next upload
    }
  };

  const renderAnusuchiOneTable = () => (
    <div className="">
      {groupedData.map((group, gIndex) => (
        <div>
          {/* <div key={gIndex} style={{ pageBreakAfter: 'always' }}> */}
          <h3 className="text-center text-xs m-6">
            गाव: <span className="font-bold pr-3">{group.village}</span>
            तालुका: <span className="font-bold pr-3">{group.taluka}</span>
            जिल्हा: <span className="font-bold">{group.dist}</span>
          </h3>

          {/* Center the table */}
          {/* <div className="flex justify-center">
            <table className="border border-black border-collapse mb-4 text-sm w-auto max-w-md">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border border-black p-2">अ. क्र.</th>
                  <th className="border border-black p-2">गट क्रमांक</th>
                  <th className="border border-black p-2">संपादना प्रस्तावित क्षेत्र (हे.आर)</th>
                </tr>
              </thead>
              <tbody>
                {group.records.map((record, index) => (
                  <tr key={index}>
                    <td className="border border-black p-2 text-center">{index + 1}</td>
                    <td className="border border-black p-2 text-center">{record.survey_no}</td>
                    <td className="border border-black p-2 text-center">
                      {parseFloat(record.aqr_area || 0).toFixed(2)}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="2" className="border border-black p-2 font-bold text-right">एकूण</td>
                  <td className="border border-black p-2 font-bold text-center">
                    {parseFloat(group.total || 0).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div> */}
          <div className="w-full">
            <table className="border border-black border-collapse mb-4 text-sm w-full">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border border-black p-2 text-center">अ. क्र.</th>
                  <th className="border border-black p-2 text-center">भूमापन किंवा गट क्रमांक</th>
                  <th className="border border-black p-2 text-center">संपादनाचे अंदाजित क्षेत्र (हेक्टरमध्ये      )</th>
                </tr>
              </thead>
              <tbody>
                {group.records.map((record, index) => (
                  <tr key={index}>
                    <td className="border border-black p-2 text-center">{index + 1}</td>
                    <td className="border border-black p-2 text-center">{record.survey_no}</td>
                    <td className="border border-black p-2 text-center">
                      {parseFloat(record.aqr_area || 0).toFixed(2)}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="2" className="border border-black p-2 font-bold text-right">एकूण क्षेत्र</td>
                  <td className="border border-black p-2 font-bold text-center">
                    {parseFloat(group.total || 0).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      ))}

    </div>
  );

  if (loadingRecords) {
    return (
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex justify-center items-center h-80">
          <div className="text-center animate-float">
            <div className="inline-flex relative">
              <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
              <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
              </div>
            </div>
            <p className="text-gray-400 mt-4">{translations[language]?.LoadingPrambhikAdhisuchna}</p>
          </div>
        </div>
      </div>
    );
  }

  // Helper function to get field value or fallback
  const getFieldValue = (fieldName, fallback = '') => {
    return formData[fieldName] || fallback;
  };

  // UPDATED: Default Section 1 content function
  const getDefaultSection1Content = () => {
    return `ज्याअर्थी, भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा आणि पारदर्शकतेचा हक्क अधिनियम, 2013 (2013 चा 30) याच्या कलम 3 च्या खंड (ए) च्या परंतुकाव्दारे प्रदान करण्यात आलेल्या अधिकारांचा वापर करून काढण्यात आलेली शासकीय अधिसूचना, महसूल व वन विभाग क्र.संकीर्ण 11/2014/प्र.क्र. 77 (भाग-2)/अ-2, दिनांक 11 सप्टेंबर 2015 (यात यापुढे जिचा निर्देश उक्त अधिसूचना असा करण्यात आलेला आहे) याव्दारे असे अधिसूचित केले आहे की, उक्त अधिनियमाच्या कलम 3 च्या खंड (झेड ए) मध्ये व्याख्या केलेल्या एखादया सार्वजनिक प्रयोजनासाठी, एखादया जिल्हयातील 10000 हेक्टरपेक्षा अधिक नसेल इतक्या क्षेत्राकरीता जमीन संपादन करण्याच्या संबंधात, अशा जिल्हयाचा जिल्हाधिकारी हा उक्त अधिनियमाच्या प्रयोजनासाठी "समुचित शासन" असल्याचे मानण्यात येईल;

आणि ज्याअर्थी, उक्त अधिसूचनेनुसार समुचित शासन असलेल्या, बुलढाणा जिल्हयाच्या जिल्हाधिका-यांस यासोबत जोडलेल्या "अनुसूची एक" मध्ये अधिक तपशिलवार वर्णन केलेली जमीन (यात यापुढे जिचा निर्देश 'उक्त जमीन' असा करण्यात आला आहे) सार्वजनिक प्रयोजनासाठी (यात यापुढे ज्याचा निर्देश उक्त "सार्वजनिक प्रयोजन" असा करण्यात आला आहे) आवश्यक आहे अथवा तिची आवश्यकता भासण्याची शक्यता आहे, असे वाटते, ज्याच्या स्वरुपाचे विवरण यासोबत जोडलेल्या "अनुसूची दोन" मध्ये दिलेले आहे, आणि म्हणून उक्त अधिनियमाच्या कलम 11 च्या पोट कलम (1) च्या तरतुदीन्वये याव्दारे असे अधिसूचित करण्यात येते की, उक्त जमिनीची उक्त सार्वजनिक प्रयोजनासाठी आवश्यकता भासण्याची शक्यता आहे;

आणि ज्याअर्थी, प्रस्तावित भूमि संपादनाच्या अनुषंगाने बाधीत व्यक्तींचे विस्थापन करण्यास भाग पाडणारी कारणे, यासोबत जोडलेल्या "अनुसूची तीन" मध्ये दिलेली आहेत;

आणि ज्याअर्थी, सामाजिक परिणाम निर्धारण सारांश यासोबत जोडलेल्या "अनुसूची चार" मध्ये दिलेला आहे.

आणि ज्याअर्थी, कलम 43 च्या पोट कलम (1) अन्वये पुनर्वसन व पुनर्वसाहत या प्रयोजनासाठी नियुक्त केलेल्या प्रशासकाचा तपशील, यासोबत जोडलेल्या "अनुसूची पाच" मध्ये दिलेला आहे.

त्याअर्थी आता, असे घोषित करण्यात येत आहे की, उक्त अधिनियमाच्या कलम 11 च्या पोट कलम 4 अनुसार कोणतीही व्यक्ती, ही अधिसूचना प्रसिध्द झाल्याच्या दिनांकापासून ते उक्त अधिनियमाच्या प्रकरण चार खालील कार्यवाही पूर्ण होईल त्या कालावधीपर्यंत उक्त जमिनीचा अथवा तिच्या भागाचा कोणताही व्यवहार करणार नाही किंवा उक्त जमिनीवर कोणताही भार निर्माण करणार नाही;

परंतु, उक्त जमिनीच्या अथवा तिच्या भागाच्या मालकाने अर्ज केल्यावर जिल्हाधिका-यास विशेष परिस्थितीची कारणे लेखी नमुद करुन अशा मालकास उपरोक्त तरतुदीच्या प्रर्वतनातुन सूट देता येईल;

परंतु आणखी असे की, जर कोणत्याही व्यक्तीने या तरतुदीचे बुध्दीपुरस्पर उल्लंघन केल्यामुळे तिला झालेल्या कोणत्याही हानीची किंवा क्षतीची जिल्हाधिका-यांकडून भरपाई दिली जाणार नाही.

तसेच, उक्त अधिनियमाच्या कलम 11 च्या पोट कलम (5) अनुसार, जिल्हाधिकारी भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना उचित भरपाई मिळण्याचा व पारदर्शकतेचा हक्क (महाराष्ट्र) नियम, 2014 (यात यापुढे ज्यांचा निर्देश "उक्त नियम" असा करण्यात आला आहे) च्या नियम 10 च्या उपनियम (3) व्दारे विहीत केल्याप्रमाणे भूमिअभिलेखाच्या अदयावतीकरणाचे काम हाती घेणार असल्याचे व पूर्ण करणार असल्याचे देखील घोषित करण्यात येत आहे.

आणि ज्याअर्थी, उक्त अधिनियमाच्या कलम 3 च्या खंड (छ) अन्वये, समुचित शासन असलेला जिल्हाधिकारी, उक्त अधिनियमाखालील जिल्हाधिका-यांची कार्ये पार पाडण्यासाठी उपजिल्हाधिकारी ${getFieldValue('section_11_branch_name', '')}, ${getFieldValue('section_11_office_name', '')}, यास पदनिर्देशीत करीत आहे.`;
  };

  const getDefaultTip = () => {
    return `उक्त जमीनीचे नकाशे, कागदपत्रे ${laoDesi} जिल्हाधिकारी कार्यालय, बुलडाणा यांचे कार्यालयामध्ये निरीक्षण करता येईल.`;
  };

  const getDefaultAnusuchi5 = () => {
    return `अ. प्रशासक म्हणून नियुक्त करण्यात आलेल्या अधिका-याचे पदनाम

ब. प्रशासनाच्या कार्यालयाचा पत्ता

क. ज्या अधिसूचनेव्दारे प्रशासकाची नियुक्ती करण्यात आली आहे त्या अधिसूचनेचा तपशील`;
  };

  // UPDATED: Section 1 content function for display
  const getSection1Content = () => {
    // Check if we have valid content in formData.section1_content
    const userContent = formData.section1_content;

    if (userContent &&
      userContent.trim() !== '' &&
      userContent !== 'N/A' &&
      userContent !== 'null' &&
      userContent !== 'undefined' &&
      userContent.trim() !== getDefaultSection1Content().trim()) {
      // Replace \n with actual line breaks for display
      return userContent.replace(/\\n/g, '\n');
    }

    // Return default content
    return getDefaultSection1Content();
  };

  const getAnusuchi5Content = () => {
    // Check if we have valid content in formData.section1_content
    const userContent = formData.appointed_administrator;

    if (userContent &&
      userContent.trim() !== '' &&
      userContent !== 'N/A' &&
      userContent !== 'null' &&
      userContent !== 'undefined' &&
      userContent.trim() !== getDefaultAnusuchi5().trim()) {
      // Replace \n with actual line breaks for display
      return userContent.replace(/\\n/g, '\n');
    }

    // Return default content
    return getDefaultAnusuchi5();
  };

  // UPDATED:  function for display
  const getTip = () => {
    // Check if we have valid content in formData.section_11_tip
    const userContent = formData.section_11_tip;

    if (userContent &&
      userContent.trim() !== '' &&
      userContent !== 'N/A' &&
      userContent !== 'null' &&
      userContent !== 'undefined' &&
      userContent.trim() !== getDefaultTip().trim()) {
      // Replace \n with actual line breaks for display
      return userContent.replace(/\\n/g, '\n');
    }

    // Return default content
    return getDefaultTip();
  };

  // UPDATED: Section 1 content function for edit modal
  const getSection1ContentForEdit = () => {
    // Always show the current value from formData
    if (formData.section1_content &&
      formData.section1_content.trim() !== '' &&
      formData.section1_content !== 'N/A' &&
      formData.section1_content !== 'null' &&
      formData.section1_content !== 'undefined') {
      return formData.section1_content.replace(/\\n/g, '\n');
    }

    // Otherwise show default content in the edit field
    return getDefaultSection1Content();
  };

  const getAnusuchi1ContentForEdit = () => {
    // Always show the current value from formData
    if (formData.appointed_administrator &&
      formData.appointed_administrator.trim() !== '' &&
      formData.appointed_administrator !== 'N/A' &&
      formData.appointed_administrator !== 'null' &&
      formData.appointed_administrator !== 'undefined') {
      return formData.appointed_administrator.replace(/\\n/g, '\n');
    }

    // Otherwise show default content in the edit field
    return getAnusuchi5Content();
  };

  // UPDATED: Section 1 content function for edit modal
  const getTipForEdit = () => {
    // Always show the current value from formData
    if (formData.section_11_tip &&
      formData.section_11_tip.trim() !== '' &&
      formData.section_11_tip !== 'N/A' &&
      formData.section_11_tip !== 'null' &&
      formData.section_11_tip !== 'undefined') {
      return formData.section_11_tip.replace(/\\n/g, '\n');
    }

    // Otherwise show default content in the edit field
    return getDefaultTip();
  };

  // <img src="/PrathmikAdhisuchna.webp" alt="महाराष्ट्र शासन" className="mx-auto mb-1 w-30" />
  const renderNotificationDocument = (ref) => (
    <div
      ref={ref} id="notification-content"
      className="space-y-4 m-1 p-1 bg-white shadow-lg rounded-lg border border-gray-300"
      style={{
        fontFamily: "'Noto Sans Devanagari', calibri, calibri",
        minHeight: '297mm',
        width: '210mm',
        padding: '15mm',
        margin: '0 auto'
      }}>

      {/* Header */}
      <div className="text-center mb-5">
        {/* Logo */}
        <img
          src="/Emblem_of_India.svg"
          alt="महाराष्ट्र शासन"
          className="mx-auto mb-2 w-20"
        />

        {/* Government name */}
        <div className="font-bold text-sm">महाराष्ट्र शासन</div>
        <div className="font-bold text-sm">महसूल व वन विभाग</div>

        {/* Office Name */}
        <div className=" text-2xl font-semibold">
          {getFieldValue('section_11_office_name', '')}
        </div>

        {/* Branch */}
        <div className=" text-lg font-semibold">
          शाखा :- {getFieldValue('section_11_branch_name', '')}
        </div>

        {/* Address */}
        <div className="text-sm font-semibold">
          {getFieldValue('section_11_address', '')}
        </div>

      </div>

      {/* Bottom Contact Section */}
      <div className="text-xs mt-4">
        {/* First row: Email + Kramank */}
        <div className="flex justify-between">
          <div>
            ई-मेल :- <span className="font-bold text-black-700">{getFieldValue('section_11_email', laoEmail, '')}</span>
          </div>
          <div>
            दूरध्वनी क्रमांक :- {getFieldValue('section_11_mobile_no', '(07262) 242411')}
            {/* क्रमांक :- {getFieldValue('kramank_no', '')} */}
          </div>
        </div>

        {/* Horizontal line */}
        <hr className="border-black border-2 my-1" />

        {/* Second row: Reference no + Date */}
        <div className="flex justify-between">
          <div>
            {getFieldValue('section_11_notification', '')}
          </div>
          <div>
            दिनांक :- {formatDate(getFieldValue('section_11_date'))}
          </div>
        </div>
      </div>

      <p className="text-center text-lg font-bold underline">प्रारंभिक अधिसूचना</p>

      <div className="text-center font-bold text-sm mb-6">
        <div className="mb-2 pb-4">भूमिसंपादन, पुनर्वसन व पुनर्वसाहत करताना वाजवी भरपाई मिळण्याचा व पारदर्शकतेचा हक्क अधिनियम-2013 अन्वये कलम 11(1) खालील अधिसूचना</div>
        <div>भूसंपादन प्रकरण क्रमांक {getFieldValue('section_11_bhusampadan_no', '')}
        </div>
      </div>

      <div className="text-justify leading-relaxed space-y-1 text-xs">
        <div className="space-y-4">
          {getSection1Content().split('\n\n').map((paragraph, index) => (
            <p key={index} className="indent-8">
              {paragraph.trim()}
            </p>
          ))}
        </div>

        {/* <div style={{ pageBreakAfter: 'always' }} /> */}

        <div className="mt-8">
          <div className="text-center font-bold underline mt-10 mb-2 text-base">अनुसूची - एक</div>
          <p className="text-center font-bold">जमिनीचे वर्णन</p>
          {renderAnusuchiOneTable()}
        </div>

        <div className="mt-8">
          <div className="text-center font-bold underline mt-10 mb-2 text-base">अनुसूची - दोन</div>
          <div className="text-center font-bold mb-2 text-sm">सार्वजनिक प्रयोजनाच्या स्वरुपाबाबत विवरण</div>
          <div><b>प्रकल्प नाव :- </b>{getFieldValue('project_name', 'N/A')}</div>
          <div><b>प्रकल्प कार्याचे वर्णन :- </b>{getFieldValue('project_description', 'N/A')}</div>
          <div className="mt-2 font-bold">समाजाला मिळणारे लाभ :-</div>
          <div>{getFieldValue('project_social_benfit', 'N/A')}</div>
        </div>

        <div className="mt-8">
          <div className="text-center font-bold underline mt-10 mb-2 text-base">अनुसूची - तीन</div>
          <div className="text-center font-bold mb-2 text-sm">बाधित व्यक्तींचे विस्थापन करण्यास भाग पाडणारी कारणे </div>
          <div>{getFieldValue('displacement_reason', 'N/A')}</div>
        </div>

        {/* <div style={{ pageBreakAfter: 'always' }} /> */}

        <div className="mt-8">
          <div className="text-center font-bold underline mt-10 mb-2 text-base">अनुसूची - चार</div>
          <div className="text-center font-bold mb-2 text-sm"> सामाजिक प्रभाव निर्धारणाचा सारांश</div>
          <div>{getFieldValue('social_impact', 'N/A')}</div>
        </div>


        <div className="mt-8">
          <div className="text-center font-bold underline mt-10 mb-2 text-base">अनुसूची - पाच</div>
          <div className="text-center font-bold mb-2 text-sm">नियुक्त केलेल्या प्रशासकाचा तपशील</div>
          {getAnusuchi5Content().split('\n\n').map((paragraph, index) => (
            <p key={index}>
              {paragraph.trim()}
            </p>
          ))}
          {/* <div>{getFieldValue('appointed_administrator', 'N/A')}</div> */}
        </div>

        {/* {userRole !== ROLES.DATA_ENTRY && (     
        <div className="no-print">
          <div className="mt-4">
            <div className="text-center font-bold underline mt-10 mb-2 text-base">DRO नियुक्त करा</div>
            <strong>Assign DRO :</strong>{" "}
            {section11IsSendDRO === null
              ? "Not Selected"
              : section11IsSendDRO
                ? "Yes"
                : "No"}
          </div>
        </div>
        )} */}

        {(() => {
          const adminValue = getFieldValue('appointed_administrator', '');
          const hasValidValue = adminValue &&
            adminValue.trim() !== '' &&
            adminValue !== 'N/A' &&
            adminValue !== 'null' &&
            adminValue !== 'undefined';


          return hasValidValue ? (
            <>
              {/* <div className="mt-2">नियुक्त केलेल्या प्रशासकाचा तपशील :- निरंक</div> */}
              <div className="mt-6">
                टिप :-
                {getTip().split('\n\n').map((paragraph, index) => (
                  <p key={index}>
                    {paragraph.trim()}
                  </p>
                ))}
              </div>
            </>
          ) : null;
        })()}

        <div className="page-break-avoid">
          <div className="mt-8">
            <div>दिनांक :- {formatDate(getFieldValue('section_11_date'))}</div>
            <div>ठिकाण :- {groupedData && groupedData.length > 0
              ? [...new Set(groupedData.map(item => item.dist))].join(', ')
              : 'N/A'}</div>
          </div>

          {userRole !== ROLES.DATA_ENTRY && (
            <div className="flex justify-between items-end m-10">
              <div className="text-center mt-44">
                <div className="font-bold">({laoName || ''})</div>
                <div className="font-bold">{laoDesi || ''}</div>
                {/* <div className="font-bold">उपजिल्हाधिकारी भूसंपादन</div>
            <div className="font-bold">मध्यम प्रकल्प, बुलडाणा</div> */}
              </div>

              <div className="text-center mt-44">
                <div className="font-bold">({usersCollector[0]?.full_name || ''})</div>
                <div className="font-bold">{usersCollector[0]?.designation || ''}</div>
                {/* <div className="font-bold">{getFieldValue('acquisition_regional_incharge_name', '')}</div>
            <div className="font-bold">{getFieldValue('acquisition_regional_incharge_designation', '')}</div> */}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  const renderEditModal = () => (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-8">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">प्रारंभिक अधिसूचना दुरस्ती</h2>
            <button
              onClick={() => setIsEditing(false)}
              className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
            >
              ×
            </button>
          </div>

          {/* Read-only fields display */}
          {/* <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-6 rounded-xl mb-8 border-l-4 border-blue-500">
            <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
              प्रकाशन तपशील (Publication Details)
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <span className="block font-medium text-gray-600 text-sm mb-1">Acquisition Proposal No:</span>
                <span className="text-gray-900 font-semibold">{getFieldValue('acquisition_proposal_no', 'Not Set')}</span>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <span className="block font-medium text-gray-600 text-sm mb-1">Publication No:</span>
                <span className="text-gray-900 font-semibold">{getFieldValue('propsal_publication_no', 'Not Published')}</span>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm">
                <span className="block font-medium text-gray-600 text-sm mb-1">Publication Date:</span>
                <span className="text-gray-900 font-semibold">{formatDate(getFieldValue('propsal_publication_date', ''))}</span>
              </div>
            </div>
          </div> */}

          <form onSubmit={handleSubmit}>
            {/* Proposal Details */}
            <div className="mb-6">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">भूसंपादन प्रकरण तपशील</h2>
                </div>
              </div>

              {/* Two-column grid */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    भूसंपादन क्रमांक :
                  </label>
                  <input
                    type="text"
                    name="section_11_bhusampadan_no"
                    value={formData.section_11_bhusampadan_no}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Bhusampadan No..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    दिनांक :
                  </label>
                  <input
                    type="date"
                    name="section_11_date"
                    value={formatDateForInput(formData.section_11_date)}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Date..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    दूरध्वनी क्रमांक :
                  </label>
                  <input
                    type="text"
                    name="section_11_mobile_no"
                    value={formData.section_11_mobile_no}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Mobile No..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    कार्यालयाचे नाव :
                  </label>
                  <input
                    type="text"
                    name="section_11_office_name"
                    value={formData.section_11_office_name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Office name..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    शाखेचे/संकलनाचे नाव :
                  </label>
                  <input
                    type="text"
                    name="section_11_branch_name"
                    value={formData.section_11_branch_name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Branch name..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    कार्यविवरण क्रमांक :
                  </label>
                  <input
                    type="text"
                    name="section_11_notification"
                    value={formData.section_11_notification}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Notification no..."
                  />
                </div>
                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    ई-मेल :
                  </label>
                  <input
                    type="text"
                    name="section_11_email"
                    value={formData.section_11_email}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Email..."
                  />
                </div>
                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    कार्यालयाचा पत्ता व पिनकोड :
                  </label>
                  <input
                    type="text"
                    name="section_11_address"
                    value={formData.section_11_address}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter Address..."
                  />
                </div>

              </div>
            </div>

            {/* Data Entry */}
            {userRole === ROLES.DATA_ENTRY && (
              <div className="group">
                <label className="block font-semibold text-gray-700 mb-2 text-base">
                  प्राथमिक अधिसूचना जिल्हाधिकारी कार्यालयाकडे पाठविल्याची दिनांक :
                </label>
                <input
                  type="date"
                  name="section_11_backToLAODate"
                  value={formatDateForInput(formData.section_11_backToLAODate)}
                  onChange={handleInputChange}
                  className="mb-5 px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                  placeholder="Enter Date..."
                />
              </div>
            )}

            {/* Section -1 */}
            <div className="mb-6">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">भाग - एक</h2>
                </div>
              </div>

              <div className="space-y-6">
                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    तपशील:
                  </label>
                  <textarea
                    name="section1_content"
                    value={getSection1ContentForEdit()}
                    onChange={handleInputChange}
                    rows={8}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                    placeholder="Enter section content..."
                  />
                  <p className="text-sm text-gray-500 mt-1">
                    {formData.section1_content &&
                      formData.section1_content.trim() !== '' &&
                      formData.section1_content !== 'N/A' &&
                      formData.section1_content !== 'null' &&
                      formData.section1_content !== 'undefined' &&
                      formData.section1_content.trim() !== getDefaultSection1Content().trim()
                      ? 'Using custom content.'
                      : 'Default content is shown. Start typing to use custom content.'}
                  </p>
                </div>
              </div>
            </div>

            {/* अनुसूची -2 */}
            <div className="mb-6">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">अनुसूची - दोन</h2>
                </div>
              </div>

              <div className="space-y-6">
                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    प्रकल्प नाव : {formData.project_name}
                  </label>
                  {/* <input
                    type="text"
                    name="project_name"
                    value={formData.project_name}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 group-hover:border-gray-300"
                    placeholder="Enter project name..."
                  /> */}
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    प्रकल्प कार्याचे वर्णन :
                  </label>
                  <textarea
                    name="project_description"
                    value={formData.project_description}
                    onChange={handleInputChange}
                    rows={4}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                    placeholder="Enter project description..."
                  />
                </div>

                <div className="group">
                  <label className="block font-semibold text-gray-700 mb-2 text-base">
                    प्रकल्पाचे समाजाला मिळणारे लाभ :
                  </label>
                  <textarea
                    name="project_social_benfit"
                    value={formData.project_social_benfit}
                    onChange={handleInputChange}
                    rows={4}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                    placeholder="Enter social benefits..."
                  />
                </div>
              </div>
            </div>

            {/* अनुसूची -3 */}
            <div className="mb-6">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">अनुसूची - तीन</h2>
                </div>
              </div>

              <div className="group">
                <label className="block font-semibold text-gray-700 mb-2 text-base">
                  बाधित व्यक्तींचे विस्थापन करण्यास भाग पाडणारी कारणे :
                </label>
                <textarea
                  name="displacement_reason"
                  value={formData.displacement_reason}
                  onChange={handleInputChange}
                  rows={4}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                  placeholder="Enter displacement reasons..."
                />
              </div>
            </div>

            {/* अनुसूची -4 */}
            <div className="mb-6">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">अनुसूची - चार</h2>
                </div>
              </div>

              <div className="group">
                <label className="block font-semibold text-gray-700 mb-2 text-base">
                  सामाजिक प्रभाव निर्धारणाचा सारांश:
                </label>
                <textarea
                  name="social_impact"
                  value={formData.social_impact}
                  onChange={handleInputChange}
                  rows={4}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                  placeholder="Enter social impact summary..."
                />
              </div>
            </div>

            {/* अनुसूची -5 */}
            <div className="mb-6">
              <div className="flex items-center justify-center mb-6">
                <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2 rounded-full">
                  <h2 className="font-bold text-lg">अनुसूची - पाच</h2>
                </div>
              </div>

              <div className="group">
                <label className="block font-semibold text-gray-700 mb-2 text-base">
                  नियुक्त केलेल्या प्रशासकाचा तपशील :
                </label>
                <textarea
                  name="appointed_administrator"
                  value={getAnusuchi1ContentForEdit()}
                  onChange={handleInputChange}
                  rows={3}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                  placeholder="Enter administrator details..."
                />
              </div>
              <div className="mt-6">
                <div className="font-bold mb-2">पुनर्वसन:</div>

                <label className="mr-6">
                  <input
                    type="radio"
                    name="section_11_is_send_DRO"
                    checked={section11IsSendDRO === true}
                    onChange={() => setSection11IsSendDRO(true)}
                    className="mr-2"
                  />
                  Yes
                </label>

                <label>
                  <input
                    type="radio"
                    name="section_11_is_send_DRO"
                    checked={section11IsSendDRO === false}
                    onChange={() => setSection11IsSendDRO(false)}
                    className="mr-2"
                  />
                  No
                </label>
              </div>


              <div className="mt-4">
                {/* <div className="mt-4 p-4 bg-blue-50 border-l-4 border-blue-500 rounded-md font-medium text-blue-800 text-base">
                  नियुक्त केलेल्या प्रशासकाचा तपशील :- निरंक
                </div> */}

                <div className="mt-5 p-5 bg-orange-50 border-l-4 border-orange-500 rounded-md">
                  <div className="text-brown-800 text-sm leading-relaxed">
                    <span className="font-semibold text-orange-700">टिप :-</span>
                    <textarea
                      name="section_11_tip"
                      value={getTipForEdit()}
                      onChange={handleInputChange}
                      rows={2}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 resize-none group-hover:border-gray-300"
                      placeholder="Enter Tip..."
                    />
                    <p className="text-sm text-gray-500 mt-1">
                      {formData.section_11_tip &&
                        formData.section_11_tip.trim() !== '' &&
                        formData.section_11_tip !== 'N/A' &&
                        formData.section_11_tip !== 'null' &&
                        formData.section_11_tip !== 'undefined' &&
                        formData.section_11_tip.trim() !== getDefaultTip().trim()
                        ? 'Using custom Tip.'
                        : 'Default Tip is shown. Start typing to use custom Tip.'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-4 pt-6 border-t border-gray-200">
              <button
                type="button"
                onClick={() => setIsEditing(false)}
                className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 transform hover:scale-105"
              >
                {translations[language]?.Cancel}
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-8 py-3 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-indigo-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105 flex items-center justify-center space-x-3 shadow-lg"
              >
                {loading && (
                  <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                )}
                <span>{loading ? translations[language]?.Saving : translations[language]?.Save}</span>
              </button>
            </div>
          </form>
        </div>
      </div >
    </div >
  );

  // ADD THESE HELPER FUNCTIONS HERE:
  const showAlert = (title, message, type = 'info') => {
    setAlertConfig({ title, message, type });
    setShowAlertModal(true);

    // Don't auto-hide success messages so user can see them
    if (type !== 'success') {
      setTimeout(() => setShowAlertModal(false), 5000);
    }
  };

  const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
    setConfirmConfig({ title, message, onConfirm, onCancel, type });
    setShowConfirmModal(true);
  };

  return (
    <>
      <div className="bg-gray-50 min-h-screen">
        <div className="max-w-7xl mx-auto p-4">
          {/* Header */}
          <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
            <div className="flex justify-between items-center">
              <div className="flex gap-3">
                 <button
                  type="button"
                  onClick={handlePrintView}
                  className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center space-x-2"
                >
                  <span>{translations[language]?.Print}</span>
                </button>

                {(userRole === ROLES.LAO || userRole === ROLES.DATA_ENTRY) && (

                  <button
                    type="button"
                    onClick={() => setIsEditing(true)}
                    disabled={collectorEditCompletedbuttonDisabled}
                    className={`px-6 py-2 rounded-lg flex items-center space-x-2 transition-colors 
                  ${collectorEditCompletedbuttonDisabled
                        ? 'bg-gray-400 text-white cursor-not-allowed'
                        : 'bg-blue-600 text-white hover:bg-blue-700'}`}
                  // className={`px-6 py-2 rounded-lg flex items-center space-x-2 transition-colors bg-blue-600 text-white hover:bg-blue-700`}
                  >
                    <span>{translations[language]?.Edit}</span>
                  </button>

                )}
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3">
                {/* <button
                  type="button"
                  onClick={handlePrintView}
                  className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center space-x-2"
                >
                  <span>{translations[language]?.Print}</span>
                </button> */}

                {/* {userRole === ROLES.LAO && ( */}
                {/* Data Entry */}
                {/* {(userRole === ROLES.LAO || userRole === ROLES.DATA_ENTRY) && (

                  <button
                    type="button"
                    onClick={() => setIsEditing(true)}
                    disabled={collectorEditCompletedbuttonDisabled}
                    className={`px-6 py-2 rounded-lg flex items-center space-x-2 transition-colors 
                  ${collectorEditCompletedbuttonDisabled
                        ? 'bg-gray-400 text-white cursor-not-allowed'
                        : 'bg-blue-600 text-white hover:bg-blue-700'}`}
                  // className={`px-6 py-2 rounded-lg flex items-center space-x-2 transition-colors bg-blue-600 text-white hover:bg-blue-700`}
                  >
                    <span>{translations[language]?.Edit}</span>
                  </button>

                )} */}

                {userRole === ROLES.DATA_ENTRY && (
                  <>
                    <input
                      type="file"
                      id="dataEntryFileInput"
                      onChange={handleDataEntryFileSelect}
                      className="hidden"
                      accept=".pdf,.doc,.docx"
                      disabled={uploadingDataEntry}
                    />
                    <label
                      htmlFor="dataEntryFileInput"
                      className={`px-6 py-2 rounded-lg flex items-center space-x-2 cursor-pointer ${uploadingDataEntry
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-blue-600 text-white hover:bg-blue-700'
                        }`}
                    >
                      {uploadingDataEntry ? (
                        <>
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                          <span>Uploading...</span>
                        </>
                      ) : (
                        <span>Upload Document</span>
                      )}
                    </label>

                
                  </>
                )}

                {userRole === ROLES.LAO && (
                  <>
                    <div className="flex flex-wrap items-center gap-3 p-3 lg:ml-auto border border-purple-200 bg-purple-50 rounded-2xl shadow-sm min-w-max">
                    <button
                    disabled={sendToSamanvay}
                      type="button"
                      onClick={() => {
                        if (buttonDisabled) {
                          showConfirm(
                            translations[language]?.confirmResubmission,
                            translations[language]?.resubmissionWarning,
                            () => {
                              // what should happen on confirm
                              setshowSendToSamanvayModal(true);
                            },
                            () => {
                              // optional cancel callback
                              console.log("Resend cancelled");
                            },
                            "danger" // modal color type
                          );
                        } else {
                          setshowSendToSamanvayModal(true);
                        }
                      }}
                      className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                        ? "bg-red-600 text-white hover:bg-red-700"
                        : "bg-purple-600 text-white hover:bg-purple-700"
                        }`}
                      title={
                        buttonDisabled
                          ? translations[language]?.AlreadySentToSamanvayOfficerClickToResend
                          : translations[language]?.SendToSamanvayOfficer
                      }
                    >
                      <Send className="mr-2 h-4 w-4" />
                      <span>{translations[language]?.SendToSamanvayOfficer}</span>
                    </button>
                      </div>
                  </>
                )}

                {userRole === ROLES.SAMANVAY && (
                  <>
                    <div className="flex flex-wrap items-center gap-3 p-3 lg:ml-auto border border-purple-200 bg-purple-50 rounded-2xl shadow-sm min-w-max">
                   {!sendToCollector && <button
                    disabled={sendToCollector}
                      type="button"
                      onClick={() => {
                        if (buttonDisabled) {
                          showConfirm(
                            translations[language]?.confirmResubmission,
                            translations[language]?.resubmissionWarning,
                            () => {
                              // what should happen on confirm
                              setshowSendToCollectorModal(true);
                            },
                            () => {
                              // optional cancel callback
                              console.log("Resend cancelled");
                            },
                            "danger" // modal color type
                          );
                        } else {
                          setshowSendToCollectorModal(true);
                        }
                      }}
                      className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                        ? "bg-red-600 text-white hover:bg-red-700"
                        : "bg-purple-600 text-white hover:bg-purple-700"
                        }`}
                      title={
                        buttonDisabled
                          ? translations[language]?.SendToCollectorAlreadySentClickToResend
                          : translations[language]?.SendToCollector
                      }
                    >
                      <Send className="mr-2 h-4 w-4" />
                      <span>{translations[language]?.SendToCollector}</span>
                    </button>}
                    {!sendToLAO && <button
                     disabled={sendToLAO}
                      type="button"
                      onClick={() => {
                        if (isSendToLAO) {
                          showConfirm(
                            translations[language]?.confirmResubmission,
                            translations[language]?.resubmissionWarning,
                            () => setshowSendToLAOModal(true),
                            () => console.log("Resend cancelled"),
                            "danger"
                          );
                        } else {
                          setshowSendToLAOModal(true);
                        }
                      }}
                      className={`flex items-center px-4 py-2 rounded-lg transition-colors ${isSendToLAO
                        ? "bg-red-600 text-white hover:bg-red-700"
                        : "bg-purple-600 text-white hover:bg-purple-700"
                        }`}
                      title={
                        isSendToLAO
                          ? translations[language]?.AlreadySentBackToLAOClickToResend
                          : translations[language]?.sendToLAO
                      }
                    >
                      <Send className="mr-2 h-4 w-4" />
                      <span>{translations[language]?.sendToLAO}</span>
                    </button>}

                    {/* <button
                      type="button"
                      onClick={() => setShowSendToLAOTrackingModal(true)}
                      className="flex items-center px-4 py-2 rounded-lg transition-colors bg-purple-600 text-white hover:bg-purple-700"
                      title="Send Back to LAO"
                    >
                      <Send className="mr-2 h-4 w-4" />
                      <span>Send Back to LAO</span>
                    </button> */}


                      {/* Send Back to LAO */}
                {userRole === ROLES.SAMANVAY && (
                  <> {!sendToCollector &&
                    <button
                      type="button"
                      onClick={() => setShowSendToLAOTrackingModal(true)}
                      className="flex items-center px-2 py-2 rounded-lg transition-colors bg-purple-600 text-white hover:bg-purple-700"
                      title="Send Back to LAO"
                    >
                      <Send className="mr-2 h-4 w-4" />
                      <span>Send Back to LAO</span>
                    </button>}
                  </>
                )}
                    </div>
                  </>
                )}
              
                
                {userRole === ROLES.COLLECTOR && (
                  <div className="flex flex-wrap items-center gap-3 p-2 lg:ml-auto border border-purple-200 bg-purple-50 rounded-2xl shadow-sm min-w-max">
                   
                     {!sendToSamanvayFinal && <button
                      disabled={sendToSamanvayFinal}
                      type="button"
                      onClick={() => {
                        if (buttonDisabled) {
                          showConfirm(
                            translations[language]?.confirmResubmission,
                            translations[language]?.resubmissionWarning,
                            () => {
                              // what should happen on confirm
                              setshowSendToSamanvayModal(true);
                            },
                            () => {
                              // optional cancel callback
                              console.log("Resend cancelled");
                            },
                            "danger" // modal color type
                          );
                        } else {
                          setshowSendToSamanvayModal(true);
                        }
                      }}
                      className={`flex items-center px-4 py-2 rounded-lg transition-colors ${buttonDisabled
                        ? "bg-red-600 text-white hover:bg-red-700"
                        : "bg-purple-600 text-white hover:bg-purple-700"
                        }`}
                      title={
                        buttonDisabled
                          ? translations[language]?.AlreadySentToSamanvayOfficerClickToResend
                          : translations[language]?.SendToSamanvayOfficer
                      }
                    >
                      <Send className="mr-2 h-4 w-4" />
                      <span>{translations[language]?.SendToSamanvayOfficer}</span>
                    </button>}
                    {/* <button
                      type="button"
                      onClick={() => setShowSendToSamanvayTrackingModal(true)}
                      className="flex items-center px-4 py-2 rounded-lg transition-colors bg-purple-600 text-white hover:bg-purple-700"
                      title="Send Back to Samanvay"
                    >
                      <Send className="mr-2 h-4 w-4" />
                      <span>Send Back to Samanvay</span>
                    </button> */}
                  </div>
                )}
                {/* send back to Samanvay */}
                {userRole === ROLES.COLLECTOR && (
                  <div className="">
                    {/* Send Back to Samanvay — fetches previous Samanvay name automatically (no dropdown) */}
                    {/* <button
                      type="button"
                      onClick={() => setShowSendToSamanvayTrackingModal(true)}
                      className="flex items-center px-4 py-2 rounded-lg transition-colors bg-purple-600 text-white hover:bg-purple-700"
                      title="Send Back to Samanvay"
                    >
                      <Send className="mr-2 h-4 w-4" />
                      <span>Send Back to Samanvay</span>
                    </button> */}

                    {/* View Section 11 — unchanged */}
                    {/* <button
                      type="button"
                      onClick={handleViewSection11}
                      className="flex items-center px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors"
                      title={translations[language]?.viewSection11 || "View Section 11"}
                    >
                      <Eye className="mr-2 h-4 w-4" />
                      <span>{translations[language]?.viewSection11 || "View"}</span>
                    </button> */}
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Main Document Display */}
          <div className="bg-white rounded-lg shadow-sm p-6">

            {/* For SAMANVAY + COLLECTOR */}
            {(userRole === ROLES.SAMANVAY || userRole === ROLES.COLLECTOR || collectorEditCompletedbuttonDisabled) ? (

              <div className="space-y-6">
                <h2 className="text-xl font-bold text-gray-800 border-b pb-3">
                  Section 11 – Final Document
                </h2>

                {section11FileLoading ? (
                  <div className="flex justify-center items-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                  </div>
                ) : section11FileError ? (
                  <div className="bg-red-50 border-l-4 border-red-500 p-5 rounded">
                    <p className="text-red-700 font-medium">{section11FileError}</p>
                  </div>
                ) : section11FileUrl ? (
                  <div className="border border-gray-300 rounded-lg overflow-hidden shadow-inner bg-gray-50">
                    <iframe
                      src={section11FileUrl}
                      className="w-full h-[85vh] rounded"
                      title="Section 11 Document"
                    />
                  </div>
                ) : (
                  <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded text-center">
                    <p className="text-yellow-800 font-medium text-lg">
                      No Section-11 document available yet.
                    </p>
                  </div>
                )}
              </div>

            ) : userRole === ROLES.LAO ? (

              /* LAO logic */
              section11FileUrl
                ? (
                  <iframe
                    src={section11FileUrl}
                    className="w-full h-[85vh] rounded"
                    title="Section 11 Document"
                  />
                )
                : renderNotificationDocument(notificationContentRef)

            ) : (

              /* Default (Data Entry etc.) */
              renderNotificationDocument(notificationContentRef)

            )}

          </div>
        </div>
      </div>

      {/* Edit Modal */}
      {isEditing && renderEditModal()}

      {/* Send to Samanvay Modal */}
    
    {showSendToSamanvayModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              {userRole === ROLES.LAO && (<><div>LAO</div></>)}
              {userRole === ROLES.COLLECTOR && (<><div>Collector</div></>)}

              <div className="space-y-4">
                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.selectUserSamanvayOfficer} *
                  </label>
                  <select
                    value={selectedUserSamanvay}
                    onChange={(e) => setselectedUserSamanvay(e.target.value)}
                    disabled={loadingusersSamanvay}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingusersSamanvay ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                    </option>
                    {usersSamanvay.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.Remarks}
                  </label>
                  <textarea
                    value={remarksSamanvay}
                    onChange={(e) => setremarksSamanvay(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter remarks..."
                  />
                </div>            

                {/* Document 1 Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Document *
                  </label>
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    onChange={(e) => {
                      setselectedDocumentSamanvay(e.target.files[0]);
                      resetSignatureState();
                    }}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />

                  {selectedDocumentSamanvay && (
                    <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                      <div className="flex items-center justify-between mb-2">
                        <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                          Selected: {selectedDocumentSamanvay.name}
                        </p>
                        <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                          {(selectedDocumentSamanvay.size / 1024 / 1024).toFixed(2)} MB
                        </span>
                      </div>

                      <div className="flex gap-2">
                        {selectedDocumentSamanvay.type === 'application/pdf' && (
                          <>
                            {/* SIGN BUTTON */}
                            <button
                              type="button"
                              onClick={() => {
                                setActiveSamanvayDoc(1); // Track that we are signing Doc 1
                                setPdfForSigning(selectedDocumentSamanvay);
                                setShowSignaturePad(true);
                              }}
                              disabled={uploadStatus === 'uploading'}
                              className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1"
                            >
                              {uploadStatus === 'uploading' && activeSamanvayDoc === 1 ? (
                                <>
                                  <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                  Signing...
                                </>
                              ) : (
                                <>Sign Doc</>
                              )}
                            </button>

                            {/* VIEW BUTTON */}
                            <button
                              type="button"
                              onClick={() =>
                                handleViewDocument(
                                  uploadStatus === 'success' && activeSamanvayDoc === 1
                                    ? selectedSignDocument
                                    : selectedDocumentSamanvay
                                )
                              }
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                            >
                              <Eye className="h-3 w-3" /> View
                            </button>
                          </>
                        )}
                      </div>

                      {uploadStatus === 'success' && activeSamanvayDoc === 1 && (
                        <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                          ✅ Document 1 signed successfully!
                        </div>
                      )}
                      {uploadStatus === 'error' && uploadError && activeSamanvayDoc === 1 && (
                        <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                          ❌ {uploadError}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* ADDED: Document 2 Upload (ONLY FOR COLLECTOR) */}
                {userRole === ROLES.COLLECTOR && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Upload Document 2 (Optional)
                    </label>
                    <input
                      type="file"
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                      onChange={(e) => {
                        setselectedDocumentSamanvay2(e.target.files[0]);
                        resetSignatureState();
                      }}
                      className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />

                    {selectedDocumentSamanvay2 && (
                      <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                        <div className="flex items-center justify-between mb-2">
                          <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                            Selected: {selectedDocumentSamanvay2.name}
                          </p>
                          <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                            {(selectedDocumentSamanvay2.size / 1024 / 1024).toFixed(2)} MB
                          </span>
                        </div>

                        <div className="flex gap-2">
                          {selectedDocumentSamanvay2.type === 'application/pdf' && (
                            <>
                              {/* SIGN BUTTON DOC 2 */}
                              <button
                                type="button"
                                onClick={() => {
                                  setActiveSamanvayDoc(2); // Track that we are signing Doc 2
                                  setPdfForSigning(selectedDocumentSamanvay2);
                                  setShowSignaturePad(true);
                                }}
                                disabled={uploadStatus === 'uploading'}
                                className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1"
                              >
                                {uploadStatus === 'uploading' && activeSamanvayDoc === 2 ? (
                                  <>
                                    <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                    Signing...
                                  </>
                                ) : (
                                  <>Sign Doc</>
                                )}
                              </button>

                              {/* VIEW BUTTON DOC 2 */}
                              <button
                                type="button"
                                onClick={() =>
                                  handleViewDocument(
                                    // If you create a separate state for Doc 2's signature (e.g., selectedSignDocument2), place it here.
                                    // Otherwise, default to the raw file or standard signed state.
                                    uploadStatus === 'success' && activeSamanvayDoc === 2
                                      ? selectedSignDocument 
                                      : selectedDocumentSamanvay2
                                  )
                                }
                                className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1"
                              >
                                <Eye className="h-3 w-3" /> View
                              </button>
                            </>
                          )}
                        </div>

                        {uploadStatus === 'success' && activeSamanvayDoc === 2 && (
                          <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                            ✅ Document 2 signed successfully!
                          </div>
                        )}
                        {uploadStatus === 'error' && uploadError && activeSamanvayDoc === 2 && (
                          <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                            ❌ {uploadError}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => {
                    setshowSendToSamanvayModal(false);
                    setselectedDocumentSamanvay(null);
                    setselectedDocumentSamanvay2(null); // Reset the second document
                    resetSignatureState(); 
                  }} 
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToSamanvay}
                >
                  {translations[language]?.Cancel}
                </button>

                <button
                  onClick={handleSendToSamanvay}
                  disabled={sendingToSamanvay || !selectedUserSamanvay || !selectedDocumentSamanvay}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToSamanvay ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language]?.Sending}
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      {translations[language]?.Send}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

 
      {/* Send to Collector Modal */}
    {showSendToCollectorModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              {/* ... Header commented out code remains the same ... */}

              <div className="space-y-4">
                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.SelectUserCollector}*
                  </label>
                  <select
                    value={selectedUserCollector}
                    onChange={(e) => setselectedUserCollector(e.target.value)}
                    disabled={loadingusersCollector}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingusersCollector ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                    </option>
                    {usersCollectorAll.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.Remarks}
                  </label>
                  <textarea
                    value={remarksCollector}
                    onChange={(e) => setremarksCollector(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter remarks..."
                  />
                </div>

                {/* Document 1 Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Document *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setselectedDocumentCollector(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocumentCollector && (
                    <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                      <div className="flex items-center justify-between mb-2">
                        <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                          Selected: {selectedDocumentCollector.name}
                        </p>
                        <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                          {(selectedDocumentCollector.size / 1024 / 1024).toFixed(2)} MB
                        </span>
                      </div>
                      <div className="flex gap-2">
                        {selectedDocumentCollector.type === 'application/pdf' && (
                          <>
                            <button
                              type="button"
                              onClick={() => {
                                if (selectedDocumentCollector?.type === 'application/pdf') {
                                  setPdfForSigning(selectedDocumentCollector);
                                  setShowSignaturePad(true);
                                }
                              }}
                              disabled={uploadStatus === 'uploading'}
                              className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                            >
                              {uploadStatus === 'uploading' ? (
                                <>
                                  <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                  Signing...
                                </>
                              ) : (
                                <>
                                  <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                  </svg>
                                  Sign Doc
                                </>
                              )}
                            </button>
                            <button
                              type="button"
                              onClick={() => handleViewDocument(
                                uploadStatus === 'success' ? selectedSignDocument : selectedDocumentCollector
                              )}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                            >
                              <Eye className="h-3 w-3" />
                              View
                            </button>
                          </>
                        )}
                      </div>
                      {uploadStatus === 'success' && (
                        <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                          ✅ Document signed successfully!
                        </div>
                      )}
                      {uploadStatus === 'error' && uploadError && (
                        <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                          ❌ {uploadError}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* ADDED: Document 2 Upload */}
               {/* Document 2 Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Document 2 (Optional)
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setselectedDocumentCollector2(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocumentCollector2 && (
                    <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                      <div className="flex items-center justify-between mb-2">
                        <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                          Selected: {selectedDocumentCollector2.name}
                        </p>
                        <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                          {(selectedDocumentCollector2.size / 1024 / 1024).toFixed(2)} MB
                        </span>
                      </div>
                      
                      {/* Added View and Sign Buttons for Doc 2 */}
                      <div className="flex gap-2">
                        {selectedDocumentCollector2.type === 'application/pdf' && (
                          <>
                            <button
                              type="button"
                              onClick={() => {
                                if (selectedDocumentCollector2?.type === 'application/pdf') {
                                  setPdfForSigning(selectedDocumentCollector2);
                                  setShowSignaturePad(true);
                                  // NOTE: If you are tracking signature success separately, 
                                  // you may need a state like setSigningActiveDoc('doc2') here.
                                }
                              }}
                              disabled={uploadStatus === 'uploading'}
                              className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                            >
                              {uploadStatus === 'uploading' ? (
                                <>
                                  <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                  Signing...
                                </>
                              ) : (
                                <>
                                  <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                  </svg>
                                  Sign Doc
                                </>
                              )}
                            </button>
                            <button
                              type="button"
                              onClick={() => handleViewDocument(
                                // Assuming you'll create a selectedSignDocument2 state if Doc 2 is signed
                                selectedDocumentCollector2 
                              )}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                            >
                              <Eye className="h-3 w-3" />
                              View
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>

              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => {
                    setshowSendToCollectorModal(false);
                    setselectedDocumentCollector(null);
                    setselectedDocumentCollector2(null); // Clear second document on cancel
                    resetSignatureState();
                  }}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToCollector}
                >
                  {translations[language]?.Cancel}
                </button>
                <button
                  onClick={handleSendToCollector}
                  disabled={sendingToCollector || !selectedUserCollector || !selectedDocumentCollector}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToCollector ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language]?.Sending}
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      {translations[language]?.Send}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

  
      {/* Send to LAO Modal */}
   {showSendToLAOModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="space-y-4">
                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.SelectUserLAO}*
                  </label>
                  <select
                    value={selectedUserLAO}
                    onChange={(e) => setselectedUserLAO(e.target.value)}
                    disabled={loadingusersLAO}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingusersLAO ? translations[language]?.LoadingUsers : translations[language]?.SelectUser}
                    </option>
                    {usersLAO.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role || user.user_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language]?.Remarks}
                  </label>
                  <textarea
                    value={remarksLAO}
                    onChange={(e) => setremarksLAO(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter remarks..."
                  />
                </div>

                {/* Document 1 Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Document *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => {
                      setselectedDocumentLAO(e.target.files[0]);
                      resetSignatureState();
                    }}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocumentLAO && (
                    <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                      <div className="flex items-center justify-between mb-2">
                        <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                          Selected: {selectedDocumentLAO.name}
                        </p>
                        <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                          {(selectedDocumentLAO.size / 1024 / 1024).toFixed(2)} MB
                        </span>
                      </div>
                      <div className="flex gap-2">
                        {selectedDocumentLAO.type === 'application/pdf' && (
                          <>
                            <button
                              type="button"
                              onClick={() => {
                                if (selectedDocumentLAO?.type === 'application/pdf') {
                                  setActiveLAODoc(1); // Track Doc 1
                                  setPdfForSigning(selectedDocumentLAO);
                                  setShowSignaturePad(true);
                                }
                              }}
                              disabled={uploadStatus === 'uploading'}
                              className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                            >
                              {uploadStatus === 'uploading' && activeLAODoc === 1 ? (
                                <>
                                  <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                  Signing...
                                </>
                              ) : (
                                <>
                                  <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                  </svg>
                                  Sign Doc
                                </>
                              )}
                            </button>
                            <button
                              type="button"
                              onClick={() => handleViewDocument(
                                uploadStatus === 'success' && activeLAODoc === 1 ? selectedSignDocument : selectedDocumentLAO
                              )}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                            >
                              <Eye className="h-3 w-3" />
                              View
                            </button>
                          </>
                        )}
                      </div>
                      {uploadStatus === 'success' && activeLAODoc === 1 && (
                        <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                          ✅ Document 1 signed successfully!
                        </div>
                      )}
                      {uploadStatus === 'error' && uploadError && activeLAODoc === 1 && (
                        <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                          ❌ {uploadError}
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* ADDED: Document 2 Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Upload Document 2 (Optional)
                  </label>
                  <input
                    type="file"
                    onChange={(e) => {
                      setselectedDocumentLAO2(e.target.files[0]);
                      resetSignatureState();
                    }}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocumentLAO2 && (
                    <div className="mt-2 p-3 bg-green-50 rounded-lg border border-green-200">
                      <div className="flex items-center justify-between mb-2">
                        <p className="text-sm text-green-700 font-medium truncate max-w-[60%]">
                          Selected: {selectedDocumentLAO2.name}
                        </p>
                        <span className="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">
                          {(selectedDocumentLAO2.size / 1024 / 1024).toFixed(2)} MB
                        </span>
                      </div>
                      <div className="flex gap-2">
                        {selectedDocumentLAO2.type === 'application/pdf' && (
                          <>
                            <button
                              type="button"
                              onClick={() => {
                                if (selectedDocumentLAO2?.type === 'application/pdf') {
                                  setActiveLAODoc(2); // Track Doc 2
                                  setPdfForSigning(selectedDocumentLAO2);
                                  setShowSignaturePad(true);
                                }
                              }}
                              disabled={uploadStatus === 'uploading'}
                              className="px-3 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-1 transition-colors"
                            >
                              {uploadStatus === 'uploading' && activeLAODoc === 2 ? (
                                <>
                                  <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-white"></div>
                                  Signing...
                                </>
                              ) : (
                                <>
                                  <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                  </svg>
                                  Sign Doc
                                </>
                              )}
                            </button>
                            <button
                              type="button"
                              onClick={() => handleViewDocument(
                                uploadStatus === 'success' && activeLAODoc === 2 ? selectedSignDocument : selectedDocumentLAO2
                              )}
                              className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-1 transition-colors"
                            >
                              <Eye className="h-3 w-3" />
                              View
                            </button>
                          </>
                        )}
                      </div>
                      {uploadStatus === 'success' && activeLAODoc === 2 && (
                        <div className="mt-2 p-2 bg-green-100 border border-green-300 rounded text-xs text-green-700">
                          ✅ Document 2 signed successfully!
                        </div>
                      )}
                      {uploadStatus === 'error' && uploadError && activeLAODoc === 2 && (
                        <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded text-xs text-red-700">
                          ❌ {uploadError}
                        </div>
                      )}
                    </div>
                  )}
                </div>

              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => {
                    setshowSendToLAOModal(false);
                    setselectedDocumentLAO(null);
                    setselectedDocumentLAO2(null); // Clear second doc on cancel
                    resetSignatureState();
                  }}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToLAO}
                >
                  {translations[language]?.Cancel}
                </button>
                <button
                  onClick={handleSendToLAO}
                  disabled={sendingToLAO || !selectedUserLAO || !selectedDocumentLAO}
                  className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToLAO ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language]?.Sending}
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      {translations[language]?.Send}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Unified Document Viewer Modal */}
      {showDocumentViewer && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl w-full max-w-5xl h-[95vh] shadow-2xl overflow-hidden border border-gray-200">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
              <div className="flex items-center space-x-3">
                <h3 className="text-2xl font-bold text-blue-900 tracking-tight">Document Preview</h3>
              </div>
              <button
                onClick={closeDocumentViewer}
                className="w-10 h-10 rounded-full bg-gray-100 hover:bg-red-100 text-gray-500 hover:text-red-500 transition-all duration-200 flex items-center justify-center text-xl font-bold shadow-sm hover:shadow-md"
                aria-label="Close modal"
              >
                ×
              </button>
            </div>

            {/* Document Viewer Container */}
            <div className="p-6 h-[calc(95vh-100px)] flex flex-col">
              <div className="flex-1 bg-gray-50 rounded-2xl overflow-hidden shadow-inner border border-gray-200">
                {/* Document Content */}
                <div className="w-full h-full flex items-center justify-center">
                  {isPDFToView ? (
                    <iframe
                      src={fileUrlToView}
                      className="w-full h-full rounded-xl border-0 bg-white shadow-lg"
                      title="PDF Preview"
                    ></iframe>
                  ) : (
                    <img
                      src={fileUrlToView}
                      alt="File"
                      className="w-full h-full object-contain rounded-xl shadow-lg"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAlertModal && (
        <div className="fixed top-4 right-4 z-50">
          <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
            alertConfig.type === 'warning' ? 'border-yellow-500' :
              alertConfig.type === 'info' ? 'border-blue-500' :
                'border-green-500'
            }`}>
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                  alertConfig.type === 'warning' ? 'bg-yellow-100' :
                    alertConfig.type === 'info' ? 'bg-blue-100' :
                      'bg-green-100'
                  }`}>
                  <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                    alertConfig.type === 'warning' ? 'text-yellow-600' :
                      alertConfig.type === 'info' ? 'text-blue-600' :
                        'text-green-600'
                    }`}>
                    {alertConfig.type === 'error' ? '✕' :
                      alertConfig.type === 'warning' ? '⚠' :
                        alertConfig.type === 'info' ? 'ℹ' : '✓'}
                  </span>
                </div>
              </div>
              <div className="ml-3 flex-1">
                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
              </div>
              <button
                onClick={() => setShowAlertModal(false)}
                className="ml-4 text-gray-400 hover:text-gray-600"
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Simple Confirmation Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
            <div className="p-6">
              <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                  'bg-blue-100'
                }`}>
                {confirmConfig.type === 'danger' ? '⚠' :
                  confirmConfig.type === 'warning' ? '⚠' : '?'}
              </div>

              <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                {confirmConfig.title}
              </h3>

              <p className="text-gray-600 text-sm mb-6 text-center">
                {confirmConfig.message}
              </p>

              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    if (confirmConfig.onCancel) confirmConfig.onCancel();
                  }}
                  className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                >
                  {translations[language]?.Cancel}
                </button>
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                  }}
                  className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                    confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                      'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                  {translations[language]?.Confirm}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* ── SendTrackingModal: Samanvay → Send Back to LAO ── */}
      <SendTrackingModal
        isOpen={showSendToLAOTrackingModal}
        onClose={() => setShowSendToLAOTrackingModal(false)}
        role="Back_LAO"
        projectId={projectId}
        proposalId={proposalId}
        translations={translations}
        language={language}
        onSuccess={() => {
          setShowSendToLAOTrackingModal(false);
        }}
      />

      {/* ── SendTrackingModal: Collector → Send Back to Samanvay ── */}
      {/* BackToSamanvay fetches previous Samanvay user automatically and shows name (no dropdown) */}
      <SendTrackingModal
        isOpen={showSendToSamanvayTrackingModal}
        onClose={() => setShowSendToSamanvayTrackingModal(false)}
        role="Back_SamanvaySection11"
        projectId={projectId}
        proposalId={proposalId}
        translations={translations}
        language={language}
        onSuccess={() => {
          setShowSendToSamanvayTrackingModal(false);
        }}
      />

      {/* SignaturePad Modal */}
      {showSignaturePad && pdfForSigning && (
        <SignaturePad
          pdfFile={pdfForSigning}
          onSign={(signaturesArray) => {
            setShowSignaturePad(false);
            signDocument(pdfForSigning, signaturesArray).then(() => {
              setPdfForSigning(null);
            });
          }}
          onCancel={() => {
            setShowSignaturePad(false);
            setPdfForSigning(null);
          }}
        />
      )}
    </>
  );
};

export default PrathmikAdhisuchna;